import * as fromCatalogo from '../../actions/shared/catalogo.actions';

export interface CatalogoState {
  Operacion: string;
  Ejecutando: boolean;
  Respuesta: any;
  Error: any;
}

export const initialState: CatalogoState = {
    Operacion: '',
    Ejecutando: false,
    Respuesta: null,
    Error: null
};

export function CatalogoReducer(state = initialState, action: fromCatalogo.CatalogoAcciones): CatalogoState {
    switch (action.type) {
      case fromCatalogo.CatalogoActionTypes.CATALOGO_INICIAL: {
        return {
          ...state,
          Operacion: '',
          Ejecutando: false,
          Respuesta: null,
          Error: null
        };
      }
      case fromCatalogo.CatalogoActionTypes.CATALOGO_GET: {
        return {
            ...state,
            Operacion: 'Get',
            Ejecutando: true,
            Respuesta: null,
            Error: null
        };
      }
      case fromCatalogo.CatalogoActionTypes.CATALOGO_SUCCESS: {
          return {
              ...state,
              Operacion: 'Success',
              Respuesta: action.Items,
              Error: null
          }
      }
      case fromCatalogo.CatalogoActionTypes.CATALOGO_FAIL: {
          return {
              ...state,
              Operacion: 'Fail',
              Respuesta: null,
              Error: action.error
          }
      }
      default: {
        return state;
      }
    }
  }